export default __webpack_public_path__ + "static/media/eye-close.7489d144.svg";